import {File, MonitorCog, Printer, ChartNoAxesCombined, Info, CircleCheck} from "lucide-react"
import React from "react"
import Home from "../../anwendungskonfigurator/assets/images/Home.svg"
import Partner from "../../anwendungskonfigurator/assets/images/Partner.svg"
import Diagramm from "../../anwendungskonfigurator/assets/images/Diagramm.svg"
import Target from "../../anwendungskonfigurator/assets/images/Target.svg"
import Tarif from "../../anwendungskonfigurator/assets/images/Tarif.svg"
import Versorgung from "../../anwendungskonfigurator/assets/images/Versorgung.svg"
import Gear from "../../anwendungskonfigurator/assets/images/Gear.svg"
import MultiTargets from "../../anwendungskonfigurator/assets/images/MultiTargets.svg"
import Altersversicherung from "../../anwendungskonfigurator/assets/images/Altersversicherung.svg"
import LocateFixed from "../../anwendungskonfigurator/assets/images/LocateFixed.svg"
import Whiteboard from "../../anwendungskonfigurator/assets/images/Whiteboard.svg"
import Bedarfscheck from "../../anwendungskonfigurator/assets/images/Bedarfscheck.svg"
import Verkaufsunterlagen from "../../anwendungskonfigurator/assets/images/Verkaufsunterlagen.svg"
import Kundenabsicherungsprofil from "../../anwendungskonfigurator/assets/images/Kundenabsicherungsprofil.svg"
import Sprechblase from "../../anwendungskonfigurator/assets/images/Sprechblase.svg"
import Exitpfeil from "../../anwendungskonfigurator/assets/images/Exitpfeil.svg"
import Monitor from "../../anwendungskonfigurator/assets/images/Monitor.svg"
import Fabrik from "../../anwendungskonfigurator/assets/images/Fabrik.svg"

export const iconMap = {
    AutoGraph: <ChartNoAxesCombined/>,
    Home: <Home/>,
    Partner: <Partner/>,
    Diagramm: <Diagramm/>,
    MultiTargets: <MultiTargets/>,
    Target: <Target/>,
    Tarif: <Tarif/>,
    Versorgung: <Versorgung/>,
    Gear: <Gear/>,
    Altersversicherung: <Altersversicherung/>,
    Verkaufsunterlagen: <Verkaufsunterlagen/>,
    File: <File/>,
    MonitorCog: <MonitorCog/>,
    LocateFixed: <LocateFixed/>,
    Whiteboard: <Whiteboard/>,
    Bedarfscheck: <Bedarfscheck/>,
    Kundenabsicherungsprofil: <Kundenabsicherungsprofil/>,
    Sprechblase: <Sprechblase/>,
    Exitpfeil: <Exitpfeil/>,
    Printer: <Printer/>,
    Monitor: <Monitor/>,
    Fabrik: <Fabrik/>,
    Info: <Info/>,
    CircleCheck: <CircleCheck/>,
}
